export const ReviewsSection = () => (
  <section data-testid="reviews-section" className="py-16 px-6 bg-[#0a0513] border-t border-[#1e1038]">
    <div className="max-w-4xl mx-auto text-center p-8 rounded-2xl bg-[#120a21]/50 border border-[#281647] border-dashed">
      <span className="text-xs uppercase tracking-widest text-[#a020f0] font-bold mono-font">Risultati &amp; Recensioni</span>
      <h3 className="text-lg font-bold text-white mt-1 mb-2">Storie di Trasformazione</h3>
      <p className="text-xs text-[#94a3b8]">
        I risultati e le recensioni dei primi atleti del nuovo percorso appariranno qui al completamento del primo blocco.
      </p>
    </div>
  </section>
);
